import React from 'react';
import { connect } from 'react-redux';
import { requestServiceTypeDetails, downloadServiceTypeFile } from '../../../store/services-manager/ServicesManagerActions';

class ServiceFormDetails extends React.Component {
  
  componentWillMount() {
    this.props.getServiceType(this.props.serviceTypeId, {
      tenantId: this.props.tenantId,
    });
  }

  downloadFile(serviceTypeId, fileName) {
    this.props
      .downloadFile(
        serviceTypeId,
        {
          tenantId: this.props.tenantId,
        },
        fileName,
      )
      .then((response) => {
        const blob = response.payload;
        const a = document.createElement('a');
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
      });
  }

  render() {
    const {
      data: { servicetype }
    } = this.props;

    return (
      <div >
        {servicetype.files &&
          servicetype.files.map((file) => (
            <li className="list-group-item" key={file.fileName ? file.fileName : file.name}>
              <a onClick={() => this.downloadFile(servicetype.id, file.fileName)} >
                <span className="filename">{file.fileName ? file.fileName : file.name} </span>
              </a>
              {` `}
            </li>
          ))}
      </div>
    );
  }
}
export default connect(
  (state) => ({
    data: state.servicemanager,
    tenantId: state.currentUser.queryParams.tenantId,
  }),
  (dispatch) => ({
    getServiceType: (id, params) => dispatch(requestServiceTypeDetails(id, params)),
    downloadFile: (serviceTypeId, params, file) => dispatch(downloadServiceTypeFile(serviceTypeId, params, file)),
  }),
)(ServiceFormDetails);



// WEBPACK FOOTER //
// ./src/routes/service-request-manager/components/ServiceFormDetails.js